import React, { useState } from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import {
  Commas,
  getDateFormate,
  getTimeFormat,
} from "../../../../Common/AllDateTimeReleventFormate";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import AuctionOrderStatusss from "./AuctionOrderStatusss";
import { useEffect } from "react";
import NotFound from "../../../../CustomComponents/AllLoader/NotFound";
import ProfilePic from "../../../../../assests/imgs/Profileplaceholder.svg";

export default function AuctionTabsss({
  data,
  winner,
  setActiveTab,
  activeTab,
  totalbit,
}) {
  const isStatusTabActive =
    (winner?.is_mine == 1 || data?.is_mine == 1) &&
    (data?.status == 2 || data?.status == 3);

  useEffect(() => {
    if (isStatusTabActive) {
      setActiveTab("status");
    }
  }, [isStatusTabActive]);

  const blurStyle = {
    filter: "blur(3px)",
    pointerEvents: "none",
    transition: "filter 0.3s ease",
  };

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div className="tab-package">
      <ul className="nav nav-tabs">
        {(winner?.is_mine == 1 || data?.is_mine == 1) &&
        (data?.status == 2 || data?.status == 3) ? (
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == "status" ? "active" : ""}`}
              onClick={() => handleTabChange("status")}
              data-toggle="tab"
            >
              Delivery status
            </a>
          </li>
        ) : null}
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab == "description" ? "active" : ""}`}
            onClick={() => handleTabChange("description")}
            data-toggle="tab"
          >
            Description
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab == "bid" ? "active" : ""}`}
            onClick={() => handleTabChange("bid")}
            data-toggle="tab"
          >
            Bids{" "}
            {data?.is_mine != 1 && data?.auction_type == 1
              ? ""
              : `(${totalbit || 0})`}
          </a>
        </li>
      </ul>

      <div className="tab-content">
        {(winner?.is_mine == 1 || data?.is_mine == 1) &&
        (data?.status == 2 || data?.status == 3) ? (
          <div
            className={`tab-pane ${activeTab == "status" ? "active" : ""}`}
            id="status"
          >
            {Array.isArray(data?.winning_bid) &&
            data?.winning_bid?.length > 0 ? (
              <AuctionOrderStatusss
                data={data}
                winner={winner}
                totalbit={totalbit}
              />
            ) : (
              <h1>NO WINNING BID</h1>
            )}
          </div>
        ) : null}

        <div
          className={`tab-pane ${activeTab == "description" ? "active" : ""}`}
          id="description"
        >
          <div className="requirementsec">
            <h5>Product Description</h5>
            <CustomReactQuillDescription value={data?.description} />
          </div>
        </div>

        <div
          className={`tab-pane ${activeTab == "bid" ? "active" : ""}`}
          id="bid"
        >
          {data?.is_mine != 1 && data?.auction_type == 1 ? (
            <>
              <div className="sealed-section">
                <button>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/eye-off.svg`}
                    alt=""
                  />
                  Sealed
                </button>
                <h4>This is a sealed auction.</h4>
              </div>

              <div
                className="bid-table"
                style={
                  data?.is_mine != 1 && data?.auction_type == 1 ? blurStyle : {}
                }
              >
                <table className="table">
                  <thead>
                    <tr>
                      <th>Bidder Name</th>
                      <th>Bid Date</th>
                      <th>Bid Time</th>
                      <th>Bid Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>asdfgh</td>
                      <td>asdfgh</td>
                      <td>asdfgh</td>
                      <td>asdfgh</td>
                    </tr>
                    <tr>
                      <td>asdfgh</td>
                      <td>asdfgh</td>
                      <td>asdfgh</td>
                      <td>asdfgh</td>
                    </tr>

                    <tr>
                      <td>asdfgh</td>
                      <td>asdfgh</td>
                      <td>asdfgh</td>
                      <td>asdfgh</td>
                    </tr>
                    <tr>
                      <td>asdfgh</td>
                      <td>asdfgh</td>
                      <td>asdfgh</td>
                      <td>asdfgh</td>
                    </tr>
                    <tr>
                      <td>asdfgh</td>
                      <td>asdfgh</td>
                      <td>asdfgh</td>
                      <td>asdfgh</td>
                    </tr>
                    <tr>
                      <td>asdfgh</td>
                      <td>asdfgh</td>
                      <td>asdfgh</td>
                      <td>asdfgh</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          ) : null}

          {Array.isArray(data?.bids) && data?.bids.length != 0 ? (
            <div
              className="bid-table"
              style={
                data?.is_mine != 1 && data?.auction_type == 1 ? blurStyle : {}
              }
            >
              <table className="table">
                {Array.isArray(data?.bids) &&
                  data?.bids?.map((item, index) => (
                    <tbody
                      key={index}
                      style={{ background: index == 0 ? "#80eb76" : "" }}
                    >
                      <tr>
                        <td>
                          {index == 0 && <span>Top Bidder</span>}
                          <p>
                            <img src={item?.profile_image ? item?.profile_image : ProfilePic} alt="" />
                            {item?.first_name} {item?.last_name}
                          </p>
                        </td>
                        <td>{getDateFormate(item?.created_on)}</td>
                        <td>{getTimeFormat(item?.created_on)}</td>
                        <td>${Commas(item?.price)}</td>
                      </tr>
                    </tbody>
                  ))}
              </table>
            </div>
          ) : (
            <NotFound title="No Bids Available" />
          )}
        </div>
      </div>
    </div>
  );
}
